import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

export const HeaderConfiguration = styled.div`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 3px;

    span {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        display: flex;
        align-items: center;

        color: #FFFFFF;
    }
`

export const List = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    ::-webkit-scrollbar {
        width: 8px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #949494;
        border-radius: 4px;
    }
`

export const ItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    width: 100%;
    box-sizing: border-box;
    cursor: pointer;

    span {
        display: flex;
        justify-content: start;
        align-items: center;
        width: 100%;
        height: 60px;
        margin-left: 10px;
        border-bottom: 1px solid #A7A7A7;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 24px;

        color: #4D4D4D;
    }
`